export default {
	  parseData(times, isDay) {	
		    if (!times) {
				times = 0;
			}
			if ((times + '').length == 10) {
				var temp = 1;
				for (var i = (times + '').length; i < 13; i++) {
					temp *= 10;
				}
				times *= temp;
			}
			//时间戳为10位需*1000，时间戳为13位的话不需乘1000
			// let date = new Date(times * 1000);
			let date = new Date(times);
			let y = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? '0' + MM : MM; //月补0
			let d = date.getDate();
			d = d < 10 ? '0' + d : d; //天补0
			let h = date.getHours();
			h = h < 10 ? '0' + h : h; //小时补0
			let m = date.getMinutes();
			m = m < 10 ? '0' + m : m; //分钟补0
			let s = date.getSeconds();
			s = s < 10 ? '0' + s : s; //秒补0
			// var result = y + '/' + MM + '/' + d;
			var result = y + '-' + MM + '-' + d;
			if (!isDay) {
				result += ' ' + h + ':' + m //+ ':' + s;
			}
			return result;
	    },
		parseMin(times){
			if(times < 60){
				return '00:'+ times
			}else{
				var h = parseInt(times /60)
				var m = times - h*60
				if((h+'').length =='1')
				{
					h = '0'+ h
				}
				if((m+'').length =='1')
				{
					m = m +'0'
				}
				return h +':'+ m
			}
		},
		
		getNowTime(){
			//获取当前时间并打印
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth()+1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
			_this.gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
			return _this.gettime  
		},
		MinToHours(times){//分钟转小时		   
			if(times == 60){
				return '1小时'
			}else if(times< 60){
                return times +'分钟'
			}else{
               var h = parseInt(times /60)
			   var m = times - h*60				
			   return h +'小时'+ m+'分钟'
			}
		},
		clientWidth(){		   
			var clientWidth = document.documentElement.clientWidth	
			   return clientWidth			
		},
}


// WEBPACK FOOTER //
// ./src/config/common.js